module.exports = __webpack_public_path__ + "img/background-img.5c692253.png";